/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconHeatHaze: {
  name: 'heat_haze';
  data: string;
} = {
  name: 'heat_haze',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M392.176 19.439c-320.789 287.54 285.15 275.83-103.164 566.025C461.64 294.541-108.118 246.057 392.176 19.439z"/><path d="M168.554 122.227c-117.276 198.494 198.457 219.345 72.99 438.661 51.72-180.787-281.267-277.265-72.99-438.661zM405.14 58.241c-108.443 185.331 266.008 244.201 36.797 430.712 126.114-185.78-257.003-266.498-36.797-430.712z"/></svg>`,
};
